import { fileToImage, notifyError } from '@/utils/formHelper';
import bytes from 'bytes';
import imagetype from 'image-type';
import pEvent from 'p-event';

export function isValidUsername(str: string) {
  return str.length > 0;
}

export function isExternal(path: string) {
  return /^(https?:|mailto:|tel:)/.test(path);
}


//
export interface IResolution {
  width: number;
  height: number;
}

export function validateFileSize(file: File, size: string) {
  if (file.size > bytes(size)) {
    notifyError.bind(this)(`${this.$t('form["File size too large. Maximum:"]')} ${size}`);
    return false;
  }

  return true;
}

/**
 * this function will always check and validate JPG format
 * allowTypes is ignored
 *
 * @param file
 * @param size
 * @param resolution
 * @param allowTypes
 */
export async function validateImageFile(file: File, size: string, resolution: IResolution, allowTypes: string[] = ['image/jpeg']) {
  if(!validateFileSize.bind(this)(file, size)) {
    return false;
  }

  try {
    const image = await fileToImage(file);
    if (!(image.width === resolution.width && image.height === resolution.height)) {
      notifyError.bind(this)(`${this.$t('form["Image resolution required"]')} ${resolution.width} x ${resolution.height}`);
      return false;
    }

    // check jpg format
    if (!allowTypes.includes(file.type)) {
      throw new Error("image is not jpg format");
    }

    const fileReader = new FileReader();
    const load = pEvent(fileReader, 'load');
    fileReader.readAsArrayBuffer(file);
    const event = await load as any;

    const info = imagetype(event.target.result);
    if (!allowTypes.includes(info.mime)) {
      throw new Error("image is not jpg format");
    }
  } catch(e) {
    console.log(e);
    notifyError.bind(this)(this.$t('form["Only JPG format is allowed"]'));
    return false;
  }

  return true;
}
